import anime from '../libs/anime'

class Module13Valeurs {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.valeurs = document.querySelectorAll('.module-13-valeurs .valeur .valeur_titre');
    }

    let registerEvents = () => {
      for (let i = 0; i < cache.valeurs.length; i++) {
        let valeur = cache.valeurs[i];
        valeur.addEventListener('click', toggleValeur);
      }
    }

    let toggleValeur = function() { 
      let valeur = this;
      const parent = valeur.closest('.valeur_inner');
      const drop = parent.querySelector('.valeur_texte');
      if(!parent.classList.contains('active')) {
        parent.classList.add('active');
        drop.style.display = "block";
        drop.style.height = "auto";
        const height = drop.offsetHeight;
        drop.style.height = 0;

        anime({
          targets: drop,
          duration: 600,
          height: [0, height],
          easing: 'easeInOutCubic',
        });
        
      } else {
        parent.classList.remove('active');
        anime({
            targets: drop,
            duration: 600,
            height: 0,
            easing: 'easeInOutCubic',
            complete: function() {
                drop.style.display = "none";
            }
        });
      }

    }

    initFunc();
  }
}
export { Module13Valeurs }